import authAxios from "./authAxios";

export const getPermissionsList = async () => {
  let token = localStorage.getItem("access_token");
  let res = await parseJwt(token);
  return { permissions: res.data?.permissions, login_user: res?.data };
};
export const parseToken = async (token) => {
  try {
    return await JSON.parse(window.atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};

const getPermissions = async (id) => {
  return authAxios.get(`/employees/profile/${id}`);
};

export const getRolesList = async () => {
  return authAxios.get(`/roles`);
};

export const getDesignationsList = async () => {
  return authAxios.get(`employees/designation`);
};
